<template>
  <div class="front-card" :style="customStyles">
    <div class="ribbon">
      <p
        class="ribbon-text"
        :class="`${item.titleNameSize.value}-text`"
      >{{ item.name }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FrontCard',
    props: {
      item: {
        type: Object
      }
    },
    computed: {
      customStyles() {
        let backgroundImageUrl = ''

        const {
          file,
          backgroundColor,
          backgroundSize,
          backgroundPositionX,
          backgroundPositionY,
        } = this.item

        if (file) {
          backgroundImageUrl = file.dataUrl
        }

        return {
          'background-color': backgroundColor,
          'background-image': `url(${backgroundImageUrl})`,
          'background-position': `${backgroundPositionX}% ${backgroundPositionY}% !important`,
          'background-size': backgroundSize
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .front-card {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-end;
    width: 100%;

    .ribbon {
      background: rgba(0,0,0,.5);
      color: white;
      height: auto;
      text-align: center;
      text-shadow: 1px 1px 4px black;
      width: 100%;

      .ribbon-text {
        font-family: "Mr Eaves Small Caps";
        margin: 0 !important;

        $sizes: 'tiny', 'small', 'medium', 'large', 'huge';

        @each $size in $sizes {
          $increase-ratio: 8px;
          $starting-size: 40px;
          $index: index($sizes, $size) - 1;

          &.#{$size}-text {
            font-size: $starting-size + ($index * $increase-ratio);
          }
        }
      }
    }
  }
</style>